import { useTranslation } from "react-migration/lib/i18n/useTranslation";
import { ReportIcon } from "./ReportIcon";
import React from "react";
import { logUtilitiesReportEvent } from "react-migration/domains/sites/components/SiteCard/ReportSidebar/logUtilitiesEvent";
import { Button } from "react-migration/components/Button";
import { logEventV2, WorkbenchEventName } from "react-migration/lib/util/logEventV2";

type ReportSectionProps = {
  onButtonClick: () => void;
};

export const ReportSection: React.FC<ReportSectionProps> = ({ onButtonClick }) => {
  const { t } = useTranslation();

  const handleButtonClick = () => {
    logUtilitiesReportEvent({
      name: "Utilities Report - View Info Clicked",
    });
    logEventV2({
      name: WorkbenchEventName.WORKBENCH_CARD_CLICK,
      properties: {
        cardName: "Utilities Report",
        action: "goTo",
        clickDetail: "View utilities report",
      },
    });
    onButtonClick();
  };

  return (
    <>
      <div className="flex gap-3 p-2 border rounded-sm border-border-action">
        <ReportIcon />
        <div className="w-32 grow">
          <div className="text-sm font-bold">{t("sites.card.site_card.utilities_report")}</div>
          <div className="text-xs">{t("sites.card.site_card.utilities_report_text")}</div>
        </div>
        <Button onClick={handleButtonClick} data-testid="utilities-report-view-info-button">
          {t("sites.card.site_card.view")}
        </Button>
      </div>
    </>
  );
};
